import { render, staticRenderFns } from "./VeeSwitch.vue?vue&type=template&id=43ffe07a&"
import script from "./VeeSwitch.vue?vue&type=script&lang=js&"
export * from "./VeeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports